import { fromJS } from 'immutable';

const initialState = {
  url: 'https://entreprise.groupebcp.com/fr/tr%C3%A8s-petite-entreprise/',
  languages: [],
  civilities: [],
  activities: [],
  financingtypes: [],
  financingsubtypes: [],
  cities: [],
  subjects: [],
  success: false,
  visible: false,
  message: '',
  title: 'common.confirmation',
  loading: false,
};

export default function (state = fromJS(initialState), action) {
  if (action.type.endsWith('_ERROR'))
    return state.withMutations((s) => {
      s.set('visible', true);
      s.set('message', 'common.errorMessage');
      s.set('loading', false);
    });
  switch (action.type) {
    case 'loading':
      return state.withMutations((s) => {
        s.set('loading', true);
      });

    case 'SEND_FORM_SUCCESS':
      return state.withMutations((s) => {
        s.set('loading', false);
        s.set('message', 'common.successMessage');
        s.set('visible', true);
      });

    case 'GET_DATA_SUCCESS':
      return state.withMutations((s) => {
        s.set('loading', false);
      });
    case 'UPDATE_POPUP':
      return state.withMutations((s) => {
        s.set('success', false);
      });
    case 'CLOSE_POPUP':
      return state.withMutations((s) => {
        s.set('visible', false);
      });

    default:
      return state;
  }
}
